import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const AthleteFormFormLayout = styled.form.attrs({
  className: "flex h-full flex-col justify-between px-4 pb-4 sm:px-6 sm:pb-6",
})``;

export const AthleteFormScrollArea = styled.div.attrs({
  className: "flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto",
})``;

export const AthleteFormFieldLabel = styled.label.attrs({
  className: "block text-sm text-[var(--brand-muted)]",
})``;

export const AthleteFormFieldInput = styled.input.attrs({
  className: "brand-input",
})``;

export const AthleteFormTextBlock = styled.p.attrs({
  className: "text-sm text-[var(--brand-error-text)]",
})``;

export const AthleteFormFieldSelect = styled.select.attrs({
  className: "brand-input",
})``;

export const AthleteFormTextBlockSecondary = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;

export const AthleteFormPreviewImage = styled(FallbackImage).attrs({
  className: "mt-3 h-24 w-24 rounded-[18px] sm:h-28 sm:w-28",
})``;

export const AthleteFormSection = styled.div.attrs({
  className:
    "mt-4 flex flex-col-reverse gap-3 border-t border-[var(--brand-border)] pt-4 sm:flex-row sm:justify-between",
})``;
